export default {"src":"/_next/static/media/google-logo.f87a34b0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};